import { DateObject, type NetworkType } from '@capsicum/common';
import { Grid, SkeletonItem, Text } from '@capsicum/common-web';
import { type MyCollectible } from '@capsicum/features/digital-collectibles/shared';
import { CollectibleCard, CollectibleCardSkeleton } from '@capsicum/features/digital-collectibles/web';
import styled from 'styled-components';

export type WalletCollectiblesListProps = {
	collectibles: Array<MyCollectible>;
	onClickCollectible: (collectible: MyCollectible) => void;
	testID: string;
	title?: string;
};

export const WalletCollectiblesListSkeleton = ({ withTitle = true }) => (
	<>
		{withTitle && <S.TitleSkeleton />}
		<Grid>
			{[...Array(4)].map((_, i) => (
				<CollectibleCardSkeleton key={`collectibleCardSkeleton-` + i} />
			))}
		</Grid>
	</>
);

export const WalletCollectiblesList = ({
	collectibles,
	onClickCollectible,
	testID,
	title
}: WalletCollectiblesListProps) => (
	<>
		{title && (
			<S.Title color="main.subtle" data-testid={`${testID}-title`} variant="text5">
				{title}
			</S.Title>
		)}
		<Grid>
			{collectibles.length > 0 &&
				collectibles.map((collectible: MyCollectible, i) => (
					<CollectibleCard
						availableAt={collectible.unlockingDate ? new DateObject(collectible.unlockingDate) : undefined}
						backgroundImageUrl={collectible.partner?.rewardsBackground || ''}
						key={`collectibleCard-` + i}
						network={collectible.blockchain?.networkType as NetworkType}
						nftImageUrl={collectible.summary?.imageUrl || ''}
						optionType={collectible.optionType || ''}
						status={collectible.summary?.status}
						subtitle={collectible.summary?.description || ''}
						testID={`${testID}-${i}`}
						title={collectible.summary?.name || ''}
						onActivate={() => onClickCollectible(collectible)}
					/>
				))}
		</Grid>
	</>
);

namespace S {
	export const Title = styled(Text)`
		text-align: left;
		text-transform: uppercase;
		margin: ${({ theme }) => theme.spacings.xsmall} 0;
	`;

	export const TitleSkeleton = styled(SkeletonItem)`
		height: 14px;
		width: 100px;
		margin: ${({ theme }) => `${theme.spacings.xsmall} 0`};
	`;
}
